import { useState } from 'react';
import { ThemeProvider, useTheme } from '../../hooks/useTheme';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import CoreCapabilities from './components/CoreCapabilities';
import RWAApplications from './components/RWAApplications';
import TechnicalArchitecture from './components/TechnicalArchitecture';
import DeveloperSupport from './components/DeveloperSupport';
import ConsensusSection from './components/ConsensusSection';
import RMindSection from './components/RMindSection';
import Footer from './components/Footer';
import PageLoader from '../../components/base/PageLoader';
import BackToTop from '../../components/feature/BackToTop';
import ScrollProgress from '../../components/base/ScrollProgress';

function HomeContent() {
  const [isLoading, setIsLoading] = useState(true);
  const { isDark } = useTheme();

  // Safety net: ensure PageLoader is defined before using it
  const handleLoadComplete = () => {
    try {
      setIsLoading(false);
    } catch (error) {
      console.error('Error completing page load:', error);
      setIsLoading(false); // fallback to hide loader
    }
  };

  return (
    <div className={`min-h-screen transition-colors duration-500 ${isDark ? 'bg-[#0d1117]' : 'bg-white'}`}>
      {isLoading && <PageLoader onLoadComplete={handleLoadComplete} />}
      <ScrollProgress color="#E84A1F" height={3} />
      <Navbar />
      <HeroSection />
      <CoreCapabilities />
      <TechnicalArchitecture />
      <ConsensusSection />
      <DeveloperSupport />
      <RWAApplications />
      <RMindSection />
      <Footer />
      <BackToTop />
    </div>
  );
}

export default function HomePage() {
  return (
    <ThemeProvider>
      <HomeContent />
    </ThemeProvider>
  );
}
